import './VimeoEmbed.scss';
import { defineComponent, h } from 'vue';

export default defineComponent({
    props: {
        src: {
            required: true,
            type: String,
        },

        autoplay: {
            required: false,
            type: Boolean,
            default: false,
        },

        fullscreen: {
            required: false,
            type: Boolean,
            default: true,
        },

        pip: {
            required: false,
            type: Boolean,
            default: true,
        },
    },

    computed: {
        allow() {
            const xs = [
                'accelerometer',
                'encrypted-media',
                'gyroscope',
            ];
            if (this.autoplay)
                xs.push('autoplay');
            if (this.pip)
                xs.push('picture-in-picture');
            return xs.join('; ');
        },
    },

    render() {
        return h('div', { class: 'vimeo-embed' }, h('iframe', {
            src: `https://player.vimeo.com/video/${this.src}`,
            frameborder: '0',
            allow: this.allow,
            allowfullscreen: this.fullscreen,
        }));
    },
});
